import React, { useRef, useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';

import axios from 'axios';
import { Mensaje, MensajeSiNo } from '../mensajes2';
import { Dimmer } from '../spinner';


export const ImprimirEjecucionTrimestralIngresos = (props) => {

    let op = require('../../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');
    const idefiscal = JSON.parse(localStorage.getItem('idefiscal'));
    const efiscalanio = JSON.parse(localStorage.getItem('efiscalanio'));
    const fechaSistema = JSON.parse(localStorage.getItem('fechasistema'));

    const [activate, setActivate] = useState(false);
    const [deshabilitado, setDeshabilitado] = useState(false);
    const [operacion, setOperacion] = useState(0);
    const [activo, setActivo] = useState(true);
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const btnCancela = useRef();
    const btnAcepta = useRef();
    const txtTrimestre = useRef();

    const onChangeValidar = (e) => {
        e.preventDefault();
        var sigue = true;
        if (txtTrimestre.current.value === "") {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe Seleccionar el Trimestre!', icono: 'informacion' });
            sigue = false;
            txtTrimestre.current.focus();
        }

        else if (sigue) {
            imprimirEjecucionTrimestralIngresos(operacion, idefiscal, efiscalanio)
        }

    };

    const onChange = (e) => {

        if (e.target.id === 'trimestre') {
            setOperacion(e.target.value);
            setActivo(false);
        }
    };

    const imprimirEjecucionTrimestralIngresos = (ope, id, anio) => {
        var reporte = "";
        let fechaini;
        let fechafin;
        if (ope === '1') {
            reporte = 'Tes_CajIngresoTrimestre1b';
            fechaini = '01-01'+'-'+anio;
            fechafin = '31-03'+'-'+anio;
        } else if (ope === '2') {
            reporte = 'Tes_CajIngresoTrimestre2b';
            fechaini = '01-01'+'-'+anio;
            fechafin = '30-06'+'-'+anio;
        } else if (ope === '3') {
            reporte = 'Tes_CajIngresoTrimestre3b';
            fechaini = '01-01'+'-'+anio;
            fechafin = '30-09'+'-'+anio;
        } else if (ope === '4') {
            reporte = 'Tes_CajIngresoTrimestre4b';
            fechaini = '01-01'+'-'+anio;
            fechafin = '31-12'+'-'+anio;
        }
        var condicion = "TRUE";
        window.open(op.reportes + "/contabilidadpresupuestaria?" + "reporte=" + reporte + "&sql1=" + condicion + "&sql2="  + "'" + fechaini  + "'" + "&sql3=" + "'" + fechafin + "'" + "&idefiscal=" + id + "&anio=" + anio, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
    }

    const cancelar = () => {
        blanquear();
        props.onHideCancela();
    }

    const blanquear = () => {
        txtTrimestre.current.value = '';
        setActivo(true);
    };


    const handleCloseSi = () => {
        setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
    };

    const cerrarModal = () => {
        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
        blanquear();
    }

    return (
        <Modal
            {...props}
            size="lx"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
            backdrop="static"
            keyboard={false}
            onShow={() => {   

            }}

        >
            <Modal.Header className='azulGradiant header-modal'>
                <div className='fw-bold text-light'><h3>{'Imprimir Ejecución Trimestral de Ingresos'}</h3></div>
                <button className="bg-transparent" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={cancelar}>
                    <i className="far fa-window-close"></i>
                </button>

            </Modal.Header>
            <Modal.Body>
              <Dimmer active={activate} inverted>
       
      </Dimmer>
                <div className='container-fluid rounded'>

                    <div className="tab-content" id="ex-with-icons-content">
                        <div className="tab-pane fade show active" id="tab-1" role="tabpanel" aria-labelledby="ex-with-icons-tab-1">

                            <fieldset className="row border-azul rounded mx-auto">
                            <legend className="float-none m-0 w-auto" >Datos</legend>

                                <div className='row m-0 px-0'>

                                    
                                    <div className='mb-1 col-sm-12'>
                                        <div className="input-group input-group-sm m-0 w-100">
                                            <label className="input-group-text" id="inputGroup-sizing-sm">Trimestre:</label>
                                            <select className="form-select text-center" onChange={onChange} ref={txtTrimestre} aria-label="Default select example " defaultValue={props.fiscal ? props.fiscal.statuscat : ''} id="trimestre" >
                                                <option value="">--Seleccione--</option>
                                                <option value="1">1er Trimestre</option>
                                                <option value="2">2do Trimestre</option>
                                                <option value="3">3er Trimestre</option>
                                                <option value="4">4to Trimestre</option>
                                            </select>
                                        </div>
                                    </div>

                                </div>

                            </fieldset>

                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" ref={btnAcepta} disabled={activo} onClick={onChangeValidar} style={{ margin: '1px' }} className="btn btn-success btn-sm rounded-pill"><i className="far fa-check-circle"></i> Imprimir</button>
                <button type="button" ref={btnCancela} onClick={cancelar} style={{ margin: '1px' }} className="btn btn-sm btn-danger rounded-pill"><i className="fas fa-window-close"></i> Cancelar</button>
            </Modal.Footer>
            <Mensaje mensaje={mensaje}
                onHide={() => {
                    mensaje.titulo === 'Exito.' ?
                        cerrarModal() :
                        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
                }
                } />
            <MensajeSiNo mensaje={mensajesino}
                onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />
        </Modal>

    );
}